import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./styles.css";
import RankingLoader from "../../svg/RankingLoader";
import { selectorGetTradePosts } from "../../entities/selectors";
import { config } from "../../config";
import { NewOrder } from "../common/Order/ProgressOrder/NewOrder";

export const Ranking = ({ currentTick, steps }) => {
  const [isLsHack, setIsLsHack] = useState(false);
  const orders = useSelector(state => state.init.orders);
  const isMatch =
    steps?.[currentTick]?.ranking.BUY.length &&
    steps?.[currentTick]?.ranking.SELL.length;
  const isMatchClassName = isMatch ? "is-match" : "";

  const streamList = steps[currentTick]?.streams;
  const rankingList = steps[currentTick]?.ranking;
  const blockList = steps[currentTick]?.block_trade;

  const rankingListMatch = {
    buy: rankingList?.BUY,
    sell: rankingList?.SELL
  };
  const streamListMatch = streamList
    ?.map(item => {
      return {
        side: item.orders_by_side,
        sid: item.stream_id,
        isDone: item.is_done
      };
    })
    .filter(item => item.isDone === false);

  const blockListMatch = blockList
    ? {
        side: blockList?.orders_by_side,
        sid: blockList?.block_id
      }
    : null;

  const streamArray =
    streamListMatch?.filter(item => {
      return (
        rankingListMatch.buy.find(
          rankingBuy => rankingBuy === item?.side?.BUY
        ) &&
        rankingListMatch.sell.find(
          rankingSell => rankingSell === item?.side?.SELL
        )
      );
    }) ?? [];

  let actualArray = [];
  if (blockListMatch) {
    actualArray = [blockListMatch, ...streamArray];
  } else {
    actualArray = streamArray;
  }

  const streamColorClassName = actualArray && actualArray[0]?.sid;

  const tp = useSelector(selectorGetTradePosts);
  const isBlockList = Object.values(tp).filter(item => item.is_block === true);

  const matchRate = orderSide => {
    let rate =
      actualArray &&
      orders?.find(item => item.order_id === actualArray[0]?.side[orderSide])
        ?.max_cap;
    return rate === "LS" ? rate : rate?.slice(0, -1);
  };

  useEffect(() => {
    setIsLsHack(false);
    isBlockList.forEach(item => {
      if (Number(item.tp_id.slice(2) - 1) === currentTick) {
        setIsLsHack(true);
      }
    });
  }, [currentTick]);

  const filteredLsOrder = orders?.find(item => item.max_cap === "LS");
  const lsOrder = steps[currentTick]?.orders?.find(
    item => item.order_id === filteredLsOrder?.order_id
  );
  const lsIsMarketable = () => {
    const ls = orders.find(item => item.max_cap === "LS");
    return lsOrder?.is_marketable && lsOrder?.executed_qty < ls.size;
  };

  return (
    <div className="ranking-wrapper">
      <div className="title">{config.prioritization.title}</div>
      <div className="ranking-table-wrapper">
        <div className="ranking-side">
          <span>{config.prioritization.buyColumnTitle}</span>
          <span>{config.prioritization.sellColumnTitle}</span>
        </div>

        <div className="ranking-table">
          {actualArray?.map(item => {
            const matchBuyOrder = orders?.find(
              el => el.order_id === item?.side.BUY
            );
            const matchSellOrder = orders?.find(
              el => el.order_id === item?.side.SELL
            );
            return (
              <div className={`ranking-table-side match`}>
                <div className="match-loader">
                  <RankingLoader />
                </div>
                <div className="match-orders">
                  <div className="ranking-table-item">
                    <div className="ranking-table-item-cell match">
                      <NewOrder
                        key={item?.side.BUY}
                        id={item?.side.BUY}
                        progress={matchRate("BUY")}
                        type={matchBuyOrder?.type}
                        side="BUY"
                        isActive={true}
                        iconSize={35}
                        num={item?.side.BUY.substr(3, 1)}
                        classname="match-order-icon"
                      />
                    </div>
                  </div>
                  <div className="ranking-table-item">
                    <div className="ranking-table-item-cell match">
                      <NewOrder
                        key={item?.side.SELL}
                        id={item?.side.SELL}
                        progress={matchRate("SELL")}
                        type={matchSellOrder?.type}
                        side="SELL"
                        isActive={true}
                        iconSize={35}
                        num={item?.side.SELL.substr(3, 1)}
                        classname="match-order-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="ranking-table-side not-match">
            <div className="ranking-table-side-wrapper buy">
              <div className="ranking-table-item-wrapper">
                {steps?.[currentTick]?.ranking ? (
                  steps?.[currentTick]?.ranking.BUY.concat(
                    Array(8 - steps?.[currentTick]?.ranking.BUY?.length).fill(
                      null
                    )
                  ).map((item, i) => {
                    const order = orders?.find(el => el.order_id === item);
                    const isOrderInMatch = actualArray?.find(
                      el => el.side.BUY === item
                    );
                    return order ? (
                      !isOrderInMatch && (
                        <div
                          className={`ranking-table-item ${isMatchClassName}`}
                          key={order?.order_id}
                        >
                          <span
                            className={`ranking-table-item-cell buy ${isMatchClassName}`}
                          >
                            <NewOrder
                              key={order?.order_id}
                              id={order?.order_id}
                              side={order?.side}
                              type={order?.type}
                              progress={order?.max_cap?.slice(0, -1)}
                              ls={order?.max_cap === "LS"}
                              isActive={true}
                              iconSize={35}
                              num={item.substr(3, 1)}
                              classname="match-order-icon"
                            />
                          </span>
                        </div>
                      )
                    ) : (
                      <div className="ranking-table-item" key={i}>
                        <span className="ranking-table-item-cell" />
                      </div>
                    );
                  })
                ) : (
                  <>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="ranking-table-side-wrapper sell">
              <div>
                {steps?.[currentTick]?.ranking ? (
                  steps?.[currentTick]?.ranking.SELL.concat(
                    Array(8 - steps?.[currentTick]?.ranking.SELL?.length).fill(
                      null
                    )
                  ).map((item, i) => {
                    const order = orders?.find(el => el.order_id === item);

                    const isOrderInMatch = actualArray?.find(
                      el => el.side.SELL === item
                    );
                    return order ? (
                      !isOrderInMatch && (
                        <div
                          className={`ranking-table-item ${isMatchClassName}`}
                          key={order?.order_id}
                        >
                          <span
                            className={`ranking-table-item-cell sell ${isMatchClassName} ${streamColorClassName}`}
                          >
                            <NewOrder
                              key={order?.order_id}
                              id={order?.order_id}
                              side={order?.side}
                              type={order?.type}
                              classname="match-order-icon"
                              progress={order?.max_cap?.slice(0, -1)}
                              ls={order?.max_cap === "LS"}
                              isActive={true}
                              iconSize={35}
                              num={item.substr(3, 1)}
                            />
                          </span>
                        </div>
                      )
                    ) : (
                      <div className="ranking-table-item" key={i}>
                        <span className="ranking-table-item-cell" />
                      </div>
                    );
                  })
                ) : (
                  <>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                    <div className="ranking-table-item">
                      <span className="ranking-table-item-cell" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
